module.exports = __webpack_public_path__ + "img/hms.5c2a003f.png";